import { ITRConstants } from '../Constants';
import { ITRService } from '../Services';

export const ITRActions = {
    postITRDocuments
}

function postITRDocuments(ITR) {
    return dispatch => {
        dispatch(request());
        ITRService.postITRDocuments(ITR)
            .then(
                itr => {
                    if(itr && itr.data && itr.data.status && itr.data.status === "error"){
                        return dispatch(failure(itr))
                    }
                    else {
                        return dispatch(success(itr))    
                    }
                },
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: ITRConstants.POST_ITR_DOCUMENTS_REQUEST } }
    function success(itr) { return { type: ITRConstants.POST_ITR_DOCUMENTS_SUCCESS, itr } }
    function failure(error) { return { type: ITRConstants.POST_ITR_DOCUMENTS_FAILURE, error } }
}